import * as moment from 'moment/moment';

export const getTimezoneAbbr = (shortName: string): string => {
  if (!shortName) {
    return 'MST';
  }

  return shortName.split('(')[0];
};

export const getTimeDifference = (time1: string, time2: string): string => {
  const date1 = moment(time1);
  const date2 = moment(time2);
  const difference = date2.diff(date1, 'minutes');
  const hours = Math.trunc(difference / 60);
  const minutes = difference % 60;

  return `${hours}:${minutes}`;
};
